import { ToastContainer, toast } from "react-toastify";
import TopAdminBar from "../../components/TopAdminBar";
import { useState, useEffect } from "react";
import { request, GET, PUT } from "../../api/ApiAdapter";
import "./PrintHistoryStyle.css";
import Footer from "../../components/Footer";
import { useHistory } from "react-router-dom";
import * as Md from 'react-icons/md';

const PrintHistory = () => {
    const [usedVehicles, setUsedVehicles] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [currentVehicle, setCurrentVehicle] = useState(null);
    const history = useHistory();

    const loadUsedVehicles = async () => {
        try {
            let result = await request('prints?allUsed=' + validatePrintTypeForCars(localStorage.getItem('printType')) + '&oneWeek=Y&size=10000', GET);
            if (!result.error) {
                setUsedVehicles([...result.content]);
            }
            else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    const showConfirmation = (vehicle) => {
        setCurrentVehicle(vehicle);
        setShowConfirmModal(true);
    };

    const closeModal = () => {
        setShowConfirmModal(false);
        setCurrentVehicle(null);
    };

    const togglePrintedStatus = async () => {
        if (!currentVehicle) return;
        
        const newStatus = !currentVehicle.printed;
        setIsUpdating(true);
        
        try {
            const result = await request(`prints/label/${currentVehicle.id}`, PUT, { printed: newStatus });
            if (!result.error) {
                toast.success(`Vehicle marked as ${newStatus ? 'printed' : 'not printed'}!`);
                loadUsedVehicles();
            } else {
                toast.error("Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("An error occurred while updating status");
        } finally {
            setIsUpdating(false);
            closeModal();
        }
    };

    const validatePrintTypeForCars = (printType) => {
        if(printType === 'A'){
            return 'U,C,N';
        }
        else if(printType === 'U'){
            return 'U,C';
        }
        else if(printType === 'N'){
            return 'N';
        }
        else if(printType === 'null'){
             return 'U,C';
        }
    }

    useEffect(() => {
        loadUsedVehicles();
    }, []);

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div className="bg-white h-screen">
                <TopAdminBar/>
                <div className="ml-64 top-1 mt-3 left-0 flex items-center overflow-auto">
                    <div className="screenSize">
                        <div><b className="text-lg ml-8 mt-20">Vehicles Print History - Last 7 Days</b></div>
                        <div className="container mt-4 px-10 mb-16">
                            <div className="vertical_Table_Scroll">
                                <table className="table table-bordered border-info shadow">
                                    <thead>
                                    <tr className="header">
                                        <th>#</th>
                                        <th>STOCKNUM</th>
                                        <th>VIN</th>
                                        <th>YEAR</th>
                                        <th>MAKE</th>
                                        <th>MODEL</th>
                                        <th>PRINTED TIME</th>
                                        <th>CREATED TIME</th>
                                        <th>PRINTED</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {usedVehicles.length === 0 ?
                                        <tr align="center">
                                            <td colSpan="9">No Record Found</td>
                                        </tr> :
                                        usedVehicles.map(
                                            (usedVehicle, index) => (
                                                <tr key={usedVehicle.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{usedVehicle.stockNum}</td>
                                                    <td>{usedVehicle.vin}</td>
                                                    <td>{usedVehicle.year}</td>
                                                    <td>{usedVehicle.make}</td>
                                                    <td>{usedVehicle.model}</td>
                                                    <td>
                                                    {usedVehicle.printedTime
                                                        ? new Date(usedVehicle.printedTime).toLocaleString("sv-SE", {
                                                            year: "numeric",
                                                            month: "2-digit",
                                                            day: "2-digit",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: false,
                                                        }).replace("T", " ")
                                                        : "N/A"}
                                                    </td>
                                                    <td>
                                                    {usedVehicle.createdTime
                                                        ? new Date(usedVehicle.createdTime).toLocaleString("sv-SE", {
                                                            year: "numeric",
                                                            month: "2-digit",
                                                            day: "2-digit",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: false,
                                                        }).replace("T", " ")
                                                        : "N/A"}
                                                    </td>
                                                    <td>
                                                        <span 
                                                            onClick={() => !isUpdating && showConfirmation(usedVehicle)}
                                                            className={`status-checkbox ${usedVehicle.printed ? 'checked' : 'unchecked'}`}
                                                            style={{ cursor: isUpdating ? 'not-allowed' : 'pointer' }}
                                                        >
                                                            {usedVehicle.printed ? '✓' : '✗'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {/* Confirmation Modal */}
            {showConfirmModal && currentVehicle && (
                <div className="modal fixed w-full h-full top-0 left-0 flex md:items-center justify-center overflow-auto z-50">
                    <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50" />
                    <div className="bg-white lg:mt-0 mt-2 lg:mb-0 mb-2 rounded shadow-lg z-50 overflow-y-auto w-120">
                        <div className="modal-content py-2 text-left px-2">
                            <div className="p-2">
                                <div className="flex items-center justify-between">
                                    <div className="font-bold text-2xl text-black font-poppins py-1">
                                        Confirm Status Change
                                    </div>
                                    <button
                                        type="button"
                                        onClick={closeModal}
                                        className="p-2 ml-3 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200"
                                    >
                                        <Md.MdOutlineClose />
                                    </button>
                                </div>
                                <div className="mt-4 text-sm">
                                    <p>Are you sure you want to mark this vehicle as {!currentVehicle.printed ? 'printed' : 'not printed'}?</p>
                                    <div className="mt-4 flex items-center">
                                        <span className={`status-checkbox mr-3 ${currentVehicle.printed ? 'checked' : 'unchecked'}`}>
                                            {currentVehicle.printed ? '✓' : '✗'}
                                        </span>
                                        <span>
                                            {currentVehicle.year} {currentVehicle.make} {currentVehicle.model} 
                                            (Stock#: {currentVehicle.stockNum})
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 flex justify-end rounded-b-md">
                                <div className="space-x-4">
                                    <button
                                        onClick={closeModal}
                                        type="button"
                                        className="bg-gray-300 text-gray-700 font-poppins rounded-lg h-10 shadow-md w-24 hover:bg-gray-400"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={togglePrintedStatus}
                                        disabled={isUpdating}
                                        type="button"
                                        className="bg-blue-500 text-white font-poppins rounded-lg h-10 shadow-md w-24 hover:bg-blue-600 disabled:bg-gray-400"
                                    >
                                        {isUpdating ? 'Updating...' : 'Confirm'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default PrintHistory;